export enum CableType {
  NAYY_4x150 = 'NAYY_4x150',
  NAYY_4x35 = 'NAYY_4x35',
  Other = 'Other'
}

export interface CableStyle {
  weight: number;
  dashArray?: string;
}

export const getCableStyle = (cableType: string): CableStyle => {
  // Parse the cable type string to match our enum if possible
  const normalizedType = cableType.replace(/\s+/g, '').toUpperCase();
  switch (normalizedType) {
    case '4X150NAYY':
    case 'NAYY_4X150':
      return {
        weight: 4,           // Thicker line for 150
      };
    case '4X35NAYY':
    case 'NAYY_4X35':
      return {
        weight: 2,           // Thinner line for 35
      };
    default:
      return {
        weight: 3,           // Medium line for others
      };
  }
};

export const parseCableType = (cableType: string): CableType => {
  const normalizedType = cableType.replace(/\s+/g, '').toUpperCase();
  switch (normalizedType) {
    case '4X150NAYY':
    case 'NAYY_4X150':
      return CableType.NAYY_4x150;
    case '4X35NAYY':
    case 'NAYY_4X35':
      return CableType.NAYY_4x35;
    default:
      return CableType.Other;
  }
};

export const cableTypeToString = (cableType: CableType): string => {
  switch (cableType) {
    case CableType.NAYY_4x150:
      return '4x150 NAYY';
    case CableType.NAYY_4x35:
      return '4x35 NAYY';
    default:
      return 'Other';
  }
};
